import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'legal-imprint',
    templateUrl: './imprint.component.html',
    styleUrls: ['./imprint.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalImprintComponent {

	//** Input decorator */
	@Input() content!: string;
}
